import { AppstoreAddOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React from "react";

type ZeroPointingControlProps = {
  isOn: boolean;
  onEnter: () => any;
  onSave: () => any;
  onDiscard: () => any;
  type?: "zeroPoint" | "zeroPointWithBim";
};

export const ZeroPointingControls = ({
  isOn,
  onEnter,
  onSave,
  onDiscard,
  type = "zeroPoint",
}: ZeroPointingControlProps) => {
  if (isOn) {
    return (
      <>
        <Button type={"primary"} icon={<PlusCircleOutlined />} onClick={onSave}>
          Save
        </Button>
        <Button
          type={"primary"}
          icon={<PlusCircleOutlined />}
          danger
          onClick={onDiscard}
        >
          Cancel
        </Button>
      </>
    );
  } else {
    return (
      <Tooltip
        placement="topRight"
        title={
          type === "zeroPoint"
            ? "single image zero pointing"
            : "multiple images zero pointing"
        }
      >
        <Button
          icon={
            type === "zeroPointWithBim" ? (
              <AppstoreAddOutlined />
            ) : (
              <PlusCircleOutlined />
            )
          }
          onClick={onEnter}
        />
      </Tooltip>
    );
  }
};
